import React from "react";
import { connect } from "react-redux";
import { compose, lifecycle } from "recompose";
import { withRouter, Route } from "react-router-dom";

import {forEach, find, sortBy} from "lodash";


import Card from "react-md/lib/Cards/Card";
import CardText from "react-md/lib/Cards/CardText";
import Button from "react-md/lib/Buttons/Button";

import Host from "./Host";
import Header from "../components/ContainerHeader";
import Table from "../components/hosts/Table";

import { getHost, clearHosts } from "../actions/resourceActions";
import {DebugElement} from "../Atollon/debug";
import {TouchPageHeader, TouchPageHeader_and_content_spaceBetween} from "../AtollonTheme/ReactElements";

const Hosts = ({ match, location, history, hosts }) => {
  if (hosts) {
    if (match.url === location.pathname) {
      return (
        <div className="flex-col">
          <DebugElement text={"src/containers/Hosts.js"}/>

          <TouchPageHeader title={"Hostitelé"} />
          <TouchPageHeader_and_content_spaceBetween heightPx={50}/>

          <Card>
            <CardText>
              <div className="margin-bottom-small">
                <Table history={history} hosts={hosts} />
              </div>
              <Button icon onClick={() => history.push("/host-found")}>
                add
              </Button>
            </CardText>
          </Card>
        </div>
      );
    }

    return (
      <Route
        path={`${match.url}/:id`}
        render={() => <Host history={history} hosts={hosts} />}
      />
    );
  }

  return <div />;
};

export default compose(
  withRouter,
  connect(({ resource: { hosts } }) => ({ hosts }), { getHost, clearHosts }),
  lifecycle({
    async componentWillMount() {
      const { getHost, clearHosts } = this.props;

      clearHosts();
      await getHost();
      forEach( this.props.hosts, host => {
          getHost( host.id );
      })
    }
  })
)(Hosts);



// WEBPACK FOOTER //
// ./src/pages/Hosts.js